module.exports = __webpack_public_path__ + "static/img/sb.aa819297.svg";